export default {
  //全局使用
  global: {
    modalTitle: 'Warning',
    loginInvalid: 'The current login is invalid. Please log in again.',
  },
  errorTips: {
    paramsErr:
      'The parameters do not meet the verification, please fill in again and submit.',
  },
  //首页相关
  welcome: {
    title: 'MEET HIVE',
    enter: 'Enter',
    brand: 'MEET HIVE',
    slogan: 'A Better City Life',
  },
  official: {
    website: 'MEETHIVE ',
    product: 'Core Technology',
    about: 'About HIVE',
  },

  //登录注册相关
  //welcome.js
  login: {
    detail: {
      account: 'Account',
      password: 'Password',
      inputPhoneNumber: 'Input correct phone number',
      wrongFormat: 'Wrong format account',
      rules: 'Minimum 6-digit',
      inconsistent: 'Password dismatch',
      phone: 'Phone number',
      inputPhone: 'Input phone number',
      setAccount: 'Set account',
      startRule: 'Start with a letter',
      repeatAccount: 'Duplicate username',
      setPassword: 'Set password',
      passwordRules: 'Password at least 6 digits',
      confirmPass: 'Confirm password',
      pleaseConfirm: 'Please confirm password',
    },
    title: 'HI MEET HIVE',
    slogan: 'A Better City Life',
    checked: 'Remember password?',
    logIn: 'Sign in',
    forget: 'Forget password?',
    register: 'Register a new account',
    contract: {
      complete: 'Complete registration',
      agree: 'I have read the terms and agree to accept',
      content: '《MeetHive Terms of Service》',
      serviceContent:
        'Tips：<br/>\n' +
        '                                    The following terms are legally binding agreements between you and Dongguan Hive Intelligent Technology Co.Ltd. (referred to as "Meet Hive" in the following) in Songshan Lake Management Committee of Dongguan (referred to as "the place where this agreement is signed" in the following). This agreement will establish your rights and corresponding legal responsibilities  when using the HI sanitation software systems which are developed by Dongguan MeetHive Intelligent Technology Co.Ltd and as the software systems in this agreement; Including but not limited to computer-side websites, mobile application software, and public accounts and applets on third-party network platforms. In this agreement, "you" means any individual who uses and accesses this service.<br/>\n' +
        '                                    Please be sure to read and fully understand the terms of this agreement, including the exemption clauses that exempt or limit the responsibility of MeetHive and the restrictions on the rights of users, Click "Agree" to represent that you have read and accepted these terms. If you do not accept these all terms of this agreement, please stop registration, login or the service using. Your registration, login, service using, etc. will be considered as your agreement to be bound by this agreement.<br/>\n' +
        '                                    MeetHive may revise or update this agreement and its related supplements or documents when needed. Once the revised or updated agreements and documents are announced, they will immediately replace the original agreements and documents, and it will automatically take effect. If you do not accept the relevant amendments or updates, please stop using the HI-Sanitation services immediately or contact MeetHive; if you continue to use the HI-Sanitation services, we will regard you as having accepted the revised or updated agreements and documents.<br/>\n' +
        '\n' +
        '                                    1. User Registration<br/>\n' +
        '                                    1.1 Users should purchase the related services from Hive MeetHive, and obtain MeetHive license before registering an HI-Sanitation services account, otherwise MeetHive cannot provide the related services of HI Sanitation System for the customers.<br/>\n' +
        '                                    1.2 User Confirmation: The registered users of HI-Sanitation include the government agencies, institutions, enterprises and their staff. the users are divided into three levels, level Ⅰ, level Ⅱ and level Ⅲ: the users at levelⅠ are government agencies, institutions, and enterprises, the account allocations will be performed by MeetHive; the users at level Ⅱ are the managers of government agencies, institutions and enterprises, the account allocations will be performed by the department to which the managers belong; the users at level Ⅲ are sanitation workers, and the accounts will be assigned by the superior of the sanitation workers.<br/>\n' +
        "                                    1.3 Ways to Register: The users at all levels bind registration through mobile phone numbers. Before registration, level Ⅱ and Ⅲ users should obtain an invitation link which sent by a superior user, then click the invitation link to register. levelⅠ users' accounts are assigned by MeetHive, then log in directly after the assignment.<br/>\n" +
        '                                    1.4 Account Management: After user registrations are successful, each user gets an exclusive account, and it is forbidden to give, borrow, rent, transfer or sell. The user takes the responsibility for keeping this account and the password. Except for the fault of the platform (such as WeChat) or MeetHive, the user is fully responsible for all activities under his/her account and password.<br/>\n' +
        '\n' +
        '                                    2. Service Scope And Usage Specifications<br/>\n' +
        "                                    2.1 Level Ⅰ users can check the fill-level of all peel bins and trash bins in their jurisdictions on the computer side to assign and manage the staffs' level Ⅱ or level Ⅲ user accounts and peel bins or trash bins, also check the data of staff, peel bins or trash bins in their jurisdictions; level Ⅱ users can check the fill-level of all peel bins and trash bins in their jurisdictions on the computer side to assign and manage the staffs' level Ⅲ user accounts, also can check the data of staff, peel bins or trash bins in their jurisdictions; all the Level Ⅰ, Ⅱ, and Ⅲ users can check the fill-level of all peel bins and trash bins and optimal path in their jurisdictions on mobile terminals and applets.<br/>\n" +
        '                                    2.2 Users should obey the following rules when using HI-Sanitation services:<br/>\n' +
        "                                    1) Comply with the laws and regulations of the People's Republic of China and the government regulations;<br/>\n" +
        '                                    2) Do not use the HI-Sanitation software system for any behavior that may have adversely affect to the Internet;<br/>\n' +
        '                                    3) Do not infringe the patent, copyright, trademark, reputation, privacy, personal information or any other legal rights of any third party.br/>\n' +
        '                                    2.3 MeetHive has the right to carry out various promotions or advertising operations on the HI-Sanitation system.<br/>\n' +
        '\n' +
        '                                    3. Installation and Management of Sensors<br/>\n' +
        '                                    3.1 MeetHive has the patent ownership of the sensor labeled "HI-Tech" and is responsible for the installation and maintenance of the sensor. The ownership of the sensor belongs to MeetHive before the sensor is installed and delivered to the customer, and the ownership of the sensor belongs to the customer organization after the delivery.<br/>\n' +
        '                                    3.2 Without the agreement of MeetHive, no one can destroy or remove the sensor owned by MeetHive, and MeetHive has the right to claim against them. MeetHive also has the right to claim on behalf of the owner if it is destroyed or removed.<br/>\n' +
        '                                    3.3 No one is allowed to post ads or smear on the sensors, and do not splash or heat the sensor.<br/>\n' +
        '\n' +
        '                                    4. Intellectual Property Statement<br/>\n' +
        "                                    4.1 All copyrights, trademarks, patents, trade secrets, data and other intellectual property rights of HI-Sanitation, as well as all relevant information contents, including but not limited to: text expressions and combinations, icons, graphics, diagrams, colors, interface design, layout frames, related data, printed materials, electronic documents, etc. are protected by the People's Republic of China's Copyright Law, Trademark Law, Patent Law, Anti-Unfair Competition Law, corresponding international treaties, and other intellectual property laws and regulations. Except for software or technology authorized by the third parties, MeetHive holds the intellectual property rights of HI-Sanitation and all its contents.<br/>\n" +
        '                                    4.2 The user shall not download, copy, change, modify, link, run or create any derivative works of the software or the data released into the memory of any computer terminals during the software operations and the interactive data between the clients and the server during the software operations, including but not limited to plug-ins, plugs or unauthorized the third-party tools/services.<br/>\n' +
        '\n' +
        '                                    5. User Data and Privacy Policy<br/>\n' +
        '                                    5.1 All registration information are provided by the users to MeetHive shall be real, complete, accurate, legal and valid. If the registration information are provided by the users are changed, the users should update in time. MeetHive will check and verify the user information according to law, and the users should cooperate to provide the latest, authentic and complete information.<br/>\n' +
        '                                    5.2 MeetHive protects the privacy of users in accordance with the law, guarantees that it will not disclose or provide the registration information of a single user to the third parties, and the privacy information are protected by the law in the HI Sanitation Service System when the users use this service, but except the following cases:<br/>\n' +
        '                                    1) Obtain explicit user agreement in advance;<br/>\n' +
        '                                    2) In accordance with relevant laws and regulations;<br/>\n' +
        '                                    3) In accordance with the requirements of relevant government authorities;<br/>\n' +
        '                                    4) A ruling or order based on an effective judgment of the court;<br/>\n' +
        '                                    5) To protect the legitimate rights and profit of MeetHive or the public profit, it shall be provided to the government department or court in relevant administrative or judicial procedures.<br/>\n' +
        '\n' +
        '                                    6. Disclaimer<br/>\n' +
        '                                    6.1 MeetHive does not make any kinds of guarantees for the services, including but not limited to the timeliness, security and accuracy of the service, and direct, indirect, incidental, special and subsequent damages caused by the reasons attributable to the users in any cases and risks, MeetHive is not responsible.<br/>\n' +
        '                                    6.2 The users understand and agree that the risks of service interruptions or failures to meet the users needs caused by irresistible force, computer viruses, hacking attacks, system instability, user location, user shutdown, and any other networks, technologies, communication lines, etc. MeetHive is not at fault for these risks and is not responsible for them.<br/>\n' +
        "                                    6.3 The users fully understand and acknowledge the provisions of this agreement, and agree that MeetHive is free from any claims, penalties, liabilities, costs or losses (including but not limited to the third-party claims) related to the user's violation of the agreement. Unless agreed in this agreement or there is evidence to prove that MeetHive is seriously at fault.<br/>\n" +
        '\n' +
        '                                    7. Liability For Breach of Contract<br/>\n' +
        '                                    7.1 If MeetHive violates the relevant laws and regulations or any clauses under this agreement, causing actual losses to the users, MeetHive agrees to bear the liability for breach of contract.<br/>\n' +
        "                                    7.2 The users agree to protect and maintain the legal rights and profits of MeetHive and other users. If the user violates relevant laws and regulations or any of the terms of this agreement, and causes losses to Hive Intelligence or any third parties, the users agree to bear the liability for breach of contract, this includes, but is not limited to compensating MeetHive and protecting MeetHive from all direct and indirect losses (including any direct economic losses, losses of goodwill, and compensation paid externally, settlements, lawyers' fees, litigation costs, etc.)<br/>\n" +
        '\n' +
        '                                    8. Change and Termination of Agreement<br/>\n' +
        '                                    8.1 In view of the rapid developments and changes in the Internet service markets and related fields, the users understand and agree that MeetHive has the rights to modify any clauses of this agreement at any time. Once the contents of this agreement changes, MeetHive will directly announce the changes on the HI Sanitation Software (the form includes but is not limited to the updated version of the agreement, supplementary agreement, additional annexes to the agreement, etc.). The announcement acts as if MeetHive has notified the users to modify the contents. At the same time, MeetHive can also prompt the users to modify the contents by other appropriate methods.<br/>\n' +
        '                                    8.2 The user may not terminate this agreement unilaterally. If he needs to terminate this agreement, he should contact MeetHive for friendly negotiation to terminate it.<br/>\n' +
        '                                    8.3 MeetHive has the right to terminate this agreement unilaterally in any of the following circumstances:<br/>\n' +
        '                                    1) The user seriously violates this agreement, or repeatedly violates this agreement;<br/>\n' +
        '                                    2) There are abnormal behaviors of users, and we reasonably suspect that the users may have violated the laws or violated the provisions of this agreement. If failure to terminate this agreement may adversely affect MeetHive, other users, public order or public profits;<br/>\n' +
        "                                    3) Users have misappropriated other people's accounts, posted prohibited information, defrauded others' property, and used improper ways to make profits;<br/>\n" +
        '                                    4) Other circumstances under which this agreement should be terminated.<br/>\n' +
        '                                    8.4 After the termination of this agreement, except as otherwise expressly provided by laws, MeetHive has no obligation to disclose any information in the users accounts to the users or any designated third parties. After the termination of this agreement, MeetHive still has the following rights:<br/>\n' +
        '                                    1) Continue to save all kinds of the information retained in the HI sanitation software system;<br/>\n' +
        "                                    2) For the users' previous breaches of contract, we may still hold the user liable for any breach of contract in accordance with this agreement.<br/>\n" +
        '\n' +
        '                                    9. Applicable Laws and Dispute Resolutions<br/>\n' +
        "                                    9.1 The conclusion, performance and interpretation of this agreement and the all settlement of related disputes shall be governed by the laws of the People's Republic of China.<br/>\n" +
        '                                    9.2 If you and MeetHive have any disputes over the signings, contents, interpretations or implementations of this agreement and all its supplements and attachments, the two parties shall try to resolve them with friendly negotiation.<br/>\n' +
        '\n' +
        '                                    10. Other Regulations<br/>\n' +
        '                                    10.1 If any clauses in this agreement are completely or partially invalid or does not have any enforcement effects for any reasons, they will not affect the validity of other clauses in this agreement. In this case, the parties should negotiate to determine the new provisions within the legal scope to ensure the maximum realization of the original provisions.<br/>\n' +
        '                                    10.2 The headings in this agreement are for ease of understanding and are not limited by the headings when explaining this agreement.<br/>\n' +
        '                                    10.3 If any parties waive or delay all or parts of its rights under this agreement, it shall not be deemed to waive any other rights under this agreement or all similar rights.<br/>',
    },
    registerSure: 'Agree',
    hadOrReturn: 'Have an account already? Sign in now.',
  },
  //用户相关
  //userListItem.jsx
  userListInfo: {
    distribute: 'Assign',
    edit: 'Edit',
    del: 'Delete',
    info: 'Basic info',
    safe: 'Safety',
    weChat: 'WeChat',
    account: 'Account',
    unKnow: 'Unknown',
    shield: 'Shield',
    shieldInfo:
      'After the shielding, the WeChat account will not be able to log in to the HI sanitation normally, but you can log in normally by unblocking. Are you sure to perform this operation?',
    unblockInfo:
      'After unblocking, the micro signal can log in to HI Sanitation normally. Are you sure to perform this operation?',
    MessageReminder: 'Reminder',
    open: 'open',
    close: 'Closed',
    phone: 'Phone',
    phoneNum: 'Phone',
    unset: 'Unset',
    email: 'Email',
    emailNum: 'Email',
    okText: 'confirm',
    cancelTxt: 'cancel',
    workbenchReminder: 'Workbench overflow reminder',
    workbenchReminderTips:
      'In the list of cabinet details on the right side of the workbench, strong reminders can be set for cabinets that have not been cleaned for a long time.',
    highlight: 'highlight',
    musicTips: 'Music tips',
    untie: 'untie',
    untieTips:
      'After untiring, the WeChat account will not be able to log in to HI Sanitation. Are you sure to perform this operation?',
    untiePhone:
      'After unbinding, the mobile phone number will not be able to log in to HI Sanitation. Are you sure to perform this operation?',
    untieEmail:
      'After unbinding, the mailbox number will not be able to log in to HI Sanitation. Are you sure to perform this operation?',
  },
  //userList.jsx
  userList: {
    icon: '+ ',
    create: 'Create',
    total: 'total ',
    area: ' areas',
  },
  //创建团队相关
  //CreateGroup.js
  createTeam: {
    teamManage: 'Team Management',
    teamTip: 'Warning',
    tipDetail: "You don't have a team yet, click and create a team quickly~",
    createATeam: 'Create',
    group: {
      name: 'Group Name',
      inputName: 'Input group name!',
      rules: '(Chinese, letters, numbers, underscores)',
      digital: 'At least 6 digits',
      demands: 'Input company or other representative name',
    },
    email: {
      mailBox: 'Email',
      inputAddress: 'Input email!',
      wrongFormat: 'Wrong format',
      demands: 'Input email account',
    },
    groupAdd: {
      address: 'Group Address',
      inputAddress: 'Input group address!',
      rules: '(Chinese, letters, numbers, underscores)',
      digital: 'At least 3 digits',
      demands: 'Group address(eg：Heze City, Shandong Province)',
      create: 'Create',
    },
    info: {
      tip: 'Warning',
      congratulate:
        'Congratulations on your creation！Later, \n' +
        '                  you can modify the information you just filled in "Account" panel.',
      got: 'Ok,got it',
      create: 'Create',
    },
    createMyAccount: 'Create my account',
    completeness: 'Completeness',
  },

  //员工首页信息相关
  //item.js
  staffHomeInfo: {
    working: 'Working',
    prepareToWork: 'In preparation',
    prepareToClean: 'Preparing for clearance',
    name: 'Name',
    phone: 'Phone',
    region: 'District',
    member: 'Sanitation Workers',
    workplace: 'Working area',
    clearSpeed: 'workpiece ratio',
    unit: ' hour/bin',
    currState: 'Current status',
    workplaceState: 'Working area state',
    halfMonthNotClear: 'Delay ',
    overflow: 'Overload ',
    halfFull: 'Half ',
    empty: 'Few ',
    single: ' ',
    dailyClear: 'Daily work schedule',
    dailyClear2: 'Daily workload',
    hour: ' hour',
    kilos: ' kg',
    clearTotalTime: 'Work schedule',
    forecastInfo:
      "This trend graph shows the actual time spent by the sanitation worker of daily cleaning in the past seven days. If the time spent more than expect, then the sanitation worker's labor risk is high when working outdoors; As used less time, and less labour value will reflect about sanitation workers; Administrators can control the sanitation workers actual clear time within a certain range. If this system is needed, some suggestions can also be given by you in this regard.",
    forecastInfoDes: {
      main:
        'In the past seven days, the moments when the sanitation workers went out and cleared were mainly distributed in',
      time: " o'clock and ",
      timeClock: " o'clock ",
      average: ';Average daily cost ',
      hour: ' hour',
      action: ' for clearing.',
    },
    forecastInfoDes2: {
      clearTotal: 'Workload',
      forecastInfo:
        "This trend graph shows the total amount of garbage that the sanitation worker cleared and moved daily in past seven days.The total amount of garbage that is cleared and transported each day depends mainly on the total amount of garbage generated in this area each day;Administrators can make the total clearance of each sanitation worker's work area as equal as possible.If this system is needed, some suggestions can also be given by you in this regard.",
      unit: '(kg)',
      forecast: {
        main:
          "The garbage in this sanitation worker's work area was mainly distributed in the past seven days. ",
        time: " o'clock and ",
        timeClock: " o'clock ",
        timeDetail: 'in this two moments;',
        average: 'The worker need to clear on average each day ',
        unit: ' Kg',
        rush: ' garbage.',
      },
    },
    return: 'Back to the map',
    cleanTime: 'Clearance time',
    cleanAmount: 'Total clearance',
  },

  //管理界面 navigator.js
  manage: {
    home: 'Home',
    areaManage: 'Area',
    areaDivision: 'Area Division',
    dataCount: 'Statistics',
    staffDataCount: 'Area Trends',
    dataAnalysis: 'Analysis Platform',
    dataDetail: 'Data Detail',
    dynamicData: 'Dynamic Graph',
    equipmentManage: 'Equipment',
    equipmentWithError: 'Faulty Device',
    equipmentSpec: 'Specification',
    equipmentPower: 'Power Manage',
    accountManage: 'Account',
    myAccount: 'My Account',
    helpCenter: 'Help',
    commonQuestions: 'Common Problem',
    support: 'Support',
    exitAccount: 'Sign out',
    shrinkTab: 'Fold the tab',
    serviceAccount: 'Service Account',
  },

  manageTop: {
    exit: 'Exit',
  },

  //溢满时间
  time: {
    day: 'day',
    week: 'week',
    month: 'month',
  },

  //tips相关
  tipsInfo: {
    littleTip: 'Warning',
    chooseContent:
      'After the garage and warehouse are determined, click "Apply" on the left to complete the setup!',
    forSure: 'Yes',
    cancel: 'Cancel',
  },

  //overview.js
  toolbar: {
    leftFloatWindow: {
      header: 'Manager',
      existQuantity: 'Fill-level',
      allNoticed: 'Notified',
    },
    floatWindowDetail: {
      acknowledged: 'Got it',
      trend: 'Trend',
      trendDes:
        'This trend graph represents the existing amount of the trash bin in a certain period of time. By analyzing this graph, you can grasp the law of the trash bin clearing time, so as to carry out clearing planning, improve efficiency, and save manpower. This system can give functions in this respect if needed.',
      trendGraph: {
        day: 'day',
        week: 'week',
        month: 'month',
        noData: 'No data for this month',
        dataDes: 'real-time fill-level',
      },
    },
    pieChartDes: {
      remainCapacity: 'remaining capacity',
      occupiedCapacity: 'occupied capacity',
    },
    lineChart: {
      title: 'real-time fill-level',
    },
    tipInfo: {
      tryScroll: 'Try to scroll your mouse,',
      moreDetailed: 'the line of time will be more detailed~',
      acknowledge: 'Got it',
    },
    trendDes: {
      trend: 'Trend',
      trendInfo:
        'This trend graph represents the existing amount of the trash bin in a certain period of time. By analyzing this graph, you can grasp the law of the trash bin clearing time, so as to carry out clearing planning, improve efficiency, and save manpower. This system can give functions in this respect if needed.',
      trendIcon: 'i',
      day: 'day',
      week: 'week',
      month: 'month',
      detail: 'Detail',
      existingQuantity: 'Existing quantity',
    },
    home: 'Home',
    staffManage: 'Staff Management',
    createATeam: 'Create a team',
    controlArea: 'Area Management',
    data: 'Data',
    deviceManagement: 'Equipment Management',
    accountManage: 'Account Management',
    helpCenter: 'Help Center',
    myAccount: 'My Account',
    logout: 'sign out',
    unfoldTab: 'Unfold the tab',
    rightFloatWindow: {
      switch: 'Click to fold/unfold the sidebar.',
      haveKnown: 'Got it',
      allAcknowledge: 'Click "All notified" to handle long-term untreated bins',
      placeholder: 'Input id or name',
      allList: 'All',
      showAll: 'show all',
      showRed: 'show red',
      showOrange: 'show orange',
      showGreen: 'show green',
      existQuantity: 'Fill-level',
      showID: 'ID',
      showName:'Name',
      allNoticed: 'All notified',
      todayNeedCollect: 'Work list',
      canQuantity: 'bin',
      hideEmpty: 'hide empty',
      showEmpty: 'show empty',
    },
    edit: 'Edit',
    number: 'No.',
    exit: 'Exit',
    none: 'None',
    
  },

  //management.js
  areaManagement: {
    title: 'Area Division',
    districtAdministrator: 'districts',
    staff: 'subordinate workspace',
    typeList: 'List of district',
    subWorkArea: 'Subordinate Workspace',
    tip: 'Warning',
    confirmDelete: 'Confirm whether to "delete"',
    deleteForSure: 'Yes',
    hasSubordinateUser:
      'There is a subordinate work area in the current area. Please delete the subordinate work area before deleting the current area.',
    deleteErr: 'Failed to delete',
    cancel: 'Cancel',
    searchYouWant: 'Search you want ...',
  },

  //login.jsx
  logIn: {
    accountNotExist: 'Username does not exist',
    passwordError: 'Wrong password',
    unknownError: 'Unknown mistake',
    inputNumber: 'Input your username',
    account: 'Account',
    inputPassword: 'Input your password',
    passwordDemand: 'Set a password of 6 digits or more',
    password: 'Password',
    rememberPassword: 'Remember password',
    forgetPassword: 'Forget password？',
    loggedIn: 'Sign in',
    getVerified: 'Get verified',
    notRepeatClick: 'Do not click repeatedly',
    phoneNotBind: 'Phone number is not bound',
    wrongVerifiedCode: 'Verification code error',
    inputPhoneNumber: 'Input your phone number',
    validPhoneNumber: 'Input valid phone number',
    phone: 'Phone Number',
    inputVerifiedCode: 'Input your verification code',
    inputCorrectCode: 'Input valid verification code',
    verificationCode: 'Verification code',
    getVerifiedCode: 'The code has been sent, valid within 15 mins',
    notReceivedCode: 'Verified failure',
    notReceivedReason:
      'Abnormal network communication may cause the message to be lost. Please get it again or try again later. If your phone number is lost or disabled, choose another method to sign in.',
    emailNotBind: 'E-mail is not bound',
    inputEmailAccount: 'Input your E-mail account',
    inputValidEmail: 'Input a valid E-mail',
    getEmailVerifiedCode: 'The code has been sent, valid within 15 mins',
    emailAccount: 'E-mail account',
    notReceivedReason2:
      'Abnormal network communication may cause mail loss. Please get it again or try again later.',
    loggedInHI: 'Sign in for HI',
    noAccount: 'No account?',
    registerImmediately: '  Sign up now',
    otherWayLog: 'Other ways to sign in',
    verifiedByPhone: 'By phone',
    verifiedByEmail: 'By email',
    verifiedByPassword: 'By password',
  },

  //register.js
  register: {
    inconsistentPasswords: 'Password dismatch ',
    accountDemand: {
      inputAccount: 'Account repetition',
      atLeastLength: 'Account must be 6 digits or more',
      formatSetting:
        'Starts with letters, 6 to 18 digits (include letters, numbers, underline)',
      accountSetting: 'Set your account',
    },
    passwordDemand: {
      inputPassword: 'Input your password',
      passwordLength: 'Set a password of 6 digits or more',
      passwordSetting: 'Set your password',
      confirmPassword: 'Confirm your password',
      inputAgain: 'Confirm again',
    },
    registerAcc: 'Sign up',
    agree: 'I have read and agree to the terms',
    reminding: 'MeetHive reminds you：',
    success: 'Sign up success!',
    terms: 'MeetHive Terms of Service',
    contract: {
      serviceContent:
        'Tips：<br/>\n' +
        '                                    The following terms are legally binding agreements between you and Dongguan MeetHive Intelligent Technology Co.Ltd.（referred to as "MeetHive" in the following）in Songshan Lake Management Committee of Dongguan.（referred to as "the place where this agreement is signed" in the following）.This agreement will establish your rights and corresponding legal responsibilities when using the HI sanitation software system,HI Sanitation Software System means the software system developed by Dongguan MeetHive Intelligent Technology Co.Ltd and as a software system under this Agreement,Including but not limited to computer-side websites, mobile application software, and public accounts and applets on third-party network platforms.In this agreement, "you" means any individual who uses and accesses the Service.<br/>\n' +
        '                                    Please be sure to read and fully understand the terms of this agreement,including the exemption clauses that exempt or limit the responsibility of MeetHive and the restrictions on the rights of users,Click Agree to represent that you have read and accepted these terms.If you do not accept all the terms of this agreement, please stop registering, logging in or using the service.Your registration, login, using service, etc. will be considered as your agreement to be bound by this agreement.<br/>\n' +
        '                                    MeetHive may revise or update this agreement and its related supplements or documents when needed.Once the revised or updated agreement and documents are announced, they will immediately replace the original agreements and documents, and will automatically take effect.If you do not accept the relevant amendments or updates, please stop using the HI Sanitation services immediately or contact MeetHive; if you continue to use the HI Sanitation services, we will regard you as having accepted the revised or updated agreements and documents.<br/>\n' +
        '\n' +
        '                                    1. User Registration<br/>\n' +
        '                                    1.1 Users should purchase related services from Hive MeetHive, and obtain MeetHive license before registering an HI Sanitation services account, otherwise MeetHive cannot provide customers related services of HI Sanitation System.<br/>\n' +
        '                                    1.2 User Confirmation：Registered users of HI Sanitation include government agencies, institutions, enterprises, and staff of government agencies, institutions, and enterprises.Users are divided into three levels,Ⅰ, Ⅱ and Ⅲ：level I users are government agencies, institutions, and enterprises, account allocation is performed by MeetHive;level Ⅱ users are managers of government agencies, institutions, and enterprises, account allocation is performed by the department to which the managers belong;level Ⅲ users are sanitation workers,and an account is assigned by the superior of the sanitation worker.<br/>\n' +
        '                                    1.3 Ways to Register：Users at all levels bind registration through mobile phone numbers.Before registration, level II and III users should obtain an invitation link sent by a superior user, then click on the invitation link to register.Leval I user accounts are assigned by MeetHive, then log in directly after the assignment.<br/>\n' +
        '                                    1.4 Account Management：After user registration is successful, each user gets an exclusive account, and it is forbidden to give, borrow, rent, transfer or sell.The user takes the responsibility for keeping his account and password. Except for the fault of the platform (such as WeChat) or MeetHive, the user is fully responsible for all activities under his account and password.<br/>\n' +
        '\n' +
        '                                    2. Service Scope And Usage Specifications<br/>\n' +
        "                                    2.1 Level Ⅰ users can check the overflow status of all peel bins and trash bins in their jurisdictions on the computer side, assign and manage the staff's II or III user accounts and peel bins or trash bins, also can view the staff data and Peel bin or trash bin data in their jurisdictions;Level Ⅱ users can view the overflow status of all peel bins and trash bins in their jurisdictions on the computer side, assign and manage the staff's level III user accounts,also can view the staff data and Peel bin or trash bin data in their jurisdictions;Level Ⅰ, Ⅱ, and Ⅲ users all can check the overflow status of all peel bins and trash bins and optimal path in their jurisdictions on mobile terminals and applets.<br/>\n" +
        '                                    2.2 Users should obey the following rules when using HI sanitation services:<br/>\n' +
        "                                    1）Comply with the laws and regulations of the People's Republic of China and government regulations;<br/>\n" +
        '                                    2）Do not use the HI sanitation software system for any behavior that may have adversely affect to Internet;<br/>\n' +
        '                                    3）Do not infringe the patent, copyright, trademark, reputation, privacy, personal information or any other legal rights of any third party.br/>\n' +
        '                                    2.3 MeetHive has the right to carry out various promotion or advertising operations on the HI sanitation system.<br/>\n' +
        '\n' +
        '                                    3. Installation and Management of Sensors<br/>\n' +
        '                                    3.1 MeetHive has the patent ownership of the sensor labeled "HI-Tech" and is responsible for the installation and maintenance of the sensor.Before the sensor is installed and delivered to the customer, the ownership of the sensor belongs to MeetHive;after the delivery, the ownership of the sensor belongs to the customer organization.<br/>\n' +
        '                                    3.2 Without the agreement of MeetHive, no one may destroy or remove the sensor owned by MeetHive, and MeetHive has the right to claim against them.MeetHive also has the right to claim damages on behalf of the owner of the installed sensor if it is destroyed or removed.<br/>\n' +
        '                                    3.3 No one is allowed to post ads or smear on the sensors,and do not splash or heat the sensor.<br/>\n' +
        '\n' +
        '                                    4. Intellectual Property Statement<br/>\n' +
        "                                    4.1 All copyrights, trademarks, patents, trade secrets, data and other intellectual property rights of HI Sanitation, as well as all relevant information content,including but not limited to: text expressions and combinations, icons, graphics, diagrams, colors, interface design, layout frames, related data, printed materials, electronic documents,etc.are protected by the People's Republic of China's Copyright Law, Trademark Law, Patent Law, Anti-Unfair Competition Law, corresponding international treaties, and other intellectual property laws and regulations.Except for software or technology authorized by third parties, MeetHive holds the intellectual property rights of HI Sanitation and all its contents.<br/>\n" +
        '                                    4.2 The user shall not download, copy, change, modify, link, run or create any derivative works of the software or the data released into the memory of any computer terminal during the software operation and the interactive data between the client and the server during the software operation, including but not limited to plug-ins, plugs or unauthorized third-party tools / services.<br/>\n' +
        '\n' +
        '                                    5. User Data and Privacy Policy<br/>\n' +
        '                                    5.1 All registration information provided by the user to MeetHive shall be real, complete, accurate, legal and valid.If the registration information provided by the user is changed, the user should update it in time. MeetHive will check and verify the user information according to law, and the user should cooperate to provide the latest, authentic and complete information.<br/>\n' +
        '                                    5.2 MeetHive protects the privacy of users in accordance with the law, guarantees that it will not disclose or provide the registration information of a single user to third parties, and the privacy information protected by the law in the HI Sanitation Service System when users use the service,but except the following cases:<br/>\n' +
        '                                    1）Obtain explicit user agreement in advance;<br/>\n' +
        '                                    2）In accordance with relevant laws and regulations;<br/>\n' +
        '                                    3）According to the requirements of relevant government authorities;<br/>\n' +
        "                                    4）Under a court's effective judgment, ruling or order;<br/>\n" +
        '                                    5）To protect the legitimate rights and profit of MeetHive or the public profit, it shall be provided to the government department or court in relevant administrative or judicial procedures.<br/>\n' +
        '\n' +
        '                                    6. Disclaimer<br/>\n' +
        '                                    6.1 MeetHive does not make any kind of guarantee for the service, including but not limited to the timeliness, security and accuracy of the service, and direct, indirect, incidental, special and subsequent damages caused by the reasons attributable to the user in any case and risks, MeetHive is not responsible.<br/>\n' +
        '                                    6.2 The user understands and agrees that the risk of service interruption or failure to meet user needs caused by irresistible force, computer viruses, hacking attacks, system instability, user location, user shutdown, and any other network, technology, communication lines, etc. MeetHive is not at fault for these risks and is not responsible for them.<br/>\n' +
        "                                    6.3 The user fully understands and acknowledges the provisions of this agreement, and agrees that MeetHive is free from any claims, penalties, liabilities, costs or losses (including but not limited to third-party claims) related to the user's violation of the agreement. Unless otherwise agreed in this agreement or there is evidence to prove that MeetHive is seriously at fault.<br/>\n" +
        '\n' +
        '                                    7. Liability For Breach of Contract<br/>\n' +
        '                                    7.1 If MeetHive violates the relevant laws and regulations or any clause under this agreement, causing actual losses to the user, MeetHive agrees to bear the liability for breach of contract.<br/>\n' +
        "                                    7.2 The user agrees to protect and maintain the legal rights and profits of MeetHive and other users.If the user violates relevant laws and regulations or any of the terms of this agreement, and causes losses to Hive Intelligence or any third party, the user agrees to bear the liability for breach of contract,this includes, but is not limited to compensating MeetHive and protecting MeetHive from all direct and indirect losses (including any direct economic loss, loss of goodwill, and compensation paid externally, settlements, lawyers' fees, litigation costs, etc.)<br/>\n" +
        '\n' +
        '                                    8. Change and Termination of Agreement<br/>\n' +
        '                                    8.1 In view of the rapid development and changes in the Internet service market and related fields, users understand and agree that MeetHive has the right to modify any clause of this agreement at any time. Once the content of this agreement changes, MeetHive will directly announce the changes on the HI Sanitation Software the content of the later agreement (the form includes but is not limited to the updated version of the agreement, supplementary agreement, additional annexes to the agreement, etc.).The announcement acts as if MeetHive has notified the user to modify the content. At the same time, MeetHive can also prompt the user to modify the content by other appropriate methods.<br/>\n' +
        '                                    8.2 The user may not terminate this agreement unilaterally. If he needs to terminate this agreement, he should contact MeetHive for friendly negotiation to terminate it.<br/>\n' +
        '                                    8.3 MeetHive has the right to terminate this agreement unilaterally in any of the following circumstances:<br/>\n' +
        '                                    1）The user seriously violates this agreement, or repeatedly violates this agreement;<br/>\n' +
        '                                    2）There are abnormal behaviors of users, and we reasonably suspect that the users may have violated the law or violated the provisions of this agreement. Failure to terminate this agreement may adversely affect MeetHive, other users, public order or public profits;<br/>\n' +
        "                                    3）Users have misappropriated other people's accounts, posted prohibited information, defrauded others' property, and used improper ways to make profits;<br/>\n" +
        '                                    4）Other circumstances where this agreement should be terminated.<br/>\n' +
        '                                    8.4 After the termination of this agreement, except as otherwise expressly provided by law, Honeycomb has no obligation to disclose any information in the user account to the user or any designated third party. After the termination of this agreement, MeetHive still has the following rights:<br/>\n' +
        '                                    1）Continue to save all kinds of information retained in the HI sanitation software system;<br/>\n' +
        "                                    2）For users' previous breaches of contract, we can still pursue their liability for breach of contract in accordance with this agreement.<br/>\n" +
        '\n' +
        '                                    9. Applicable Law and Dispute Resolution<br/>\n' +
        "                                    9.1 The conclusion, performance and interpretation of this agreement and the settlement of disputes related thereto shall be governed by the laws of the People's Republic of China.<br/>\n" +
        '                                    9.2 If you and MeetHive have any disputes over the signing, content, interpretation or implementation of this agreement and all its supplements and attachments, the two parties shall try to resolve them with friendly negotiation;<br/>\n' +
        '\n' +
        '                                    10. Other Regulations<br/>\n' +
        '                                    10.1 If any clause in this agreement is completely or partially invalid or does not have any enforcement effect for any reason, it will not affect the validity of other clauses in this agreement. In this case, the parties should negotiate to determine the new provisions within the legal scope to ensure the maximum realization of the original provisions.<br/>\n' +
        '                                    10.2 The headings in this agreement are for ease of understanding and are not limited by the headings when explaining this agreement.<br/>\n' +
        '                                    10.3 If any party waives or delays all or part of its rights under this agreement, it shall not be deemed to waive any other rights under this agreement or all rights similar thereto.<br/>',
    },
    aAccount: 'Sign up an account',
    haveAcc: 'Have an account already？',
    goLogin: 'Sign in',
  },

  //welcomeStore.js
  verifiedInfo: {
    getCode: 'Get verified',
  },

  //home.js
  //退出弹窗
  exitModal: {
    tip: 'Warning',
    confirm: 'Please confirm whether to exit?',
    sure: 'Yes',
    cancel: 'Cancel',
  },

  //distributeCans.js
  //分配箱子
  allocateCans: {
    manager: 'Manger',
    area: 'Area',
    canCount: 'Bins number',
    unset: 'Unset',
    edit: 'Edit',
    inputWorkspace: 'Input workspace',
    unit: 'bins',
    willAllocate: 'To assign',
    inChargingCans: 'Assigned',
    search: 'Search',
    searchByID: 'Search by name or id',
    total: ' ',
    equipment: 'devices',
    distribute: 'Assign',
    remove: 'Remove',
    got: 'Got it',
    gotDetail: 'Checking the bin, then start distributing it.',
    toolbar: {
      home: 'Home',
      staffManagement: 'Staff Management',
      createATeam: 'Create a team',
      data: 'Data',
      equipmentManage: 'Equipment Management',
      accountManage: 'Account Management',
      help: 'Help Center',
      myAcc: 'My Account',
      unfoldTab: 'Unfold the tab',
    },
    all:'All',
  },

  //thermodynamic.js
  thermodynamic: {
    tips: 'No data!',
  },
  //DataDetail.js
  dataInfo: {
    unit: ' kg',
    detail: 'Data Detail',
    selectArea: 'All',
    import: 'Export',
    time: 'Time',
    area: 'Area',
    total: ' ',
    count: ' areas',
    prevPage: 'previous',
    nextPage: 'next',
    page: 'pages',
    daily: 'Daily',
    month: 'Monthly',
    exportData: 'Export data records',
    rangeOfArea: 'Range of area',
    chooseArea: 'Select range',
    rangeOfTime: 'Range of time',
    sure: 'Yes',
    cancel: 'Cancel',
    remind: 'MeetHive reminds you！',
    load: 'Download',
    exportTipsTxt:
      'The file is created successfully. You can click the download button to download the file.',
    TipsPermissionErr: 'Permission error',
    TipsBuildFail: 'File creation failed',
  },

  //Analysis.js
  dataAnalysis: {
    stability: 'Stable',
    weightUnit: ' t',
    collect: 'collected',
    deviceUnit: 'devices',
    isRunning: 'is operating',
    save: {
      water: 'water saved',
      electricity: 'power saved',
    },
    reduce: {
      burnAmount: 'incineration reduced',
      buryAmount: 'landfill reduced',
    },
    controlArea: 'Area assignment',
    exportReduceData: 'Export decrement data',
    operatePerson: 'Staff assignment',
    operateArea: 'Area Management',
    chooseArea: 'All',
    none: 'None',
    cleaning: ' ',
    count: ' times',
    prevPage: 'previous',
    nextPage: 'next',
    accumulate: 'recycled cumulative',
    weightUnit2: 'kt',
    weightUnit3: 'mw·h',
    estimateSaving: 'annually saved : ',
    estimateReducing: 'annually reduced : ',
    lastSevenDaysResource: 'Saved resources in 7 days',
    lastSevenDaysTrash: 'Reduced garbage in 7 days',
    personOperate: 'Staff Management',
    cleanTeam: 'teams',
    cleanState: ' is working',
    analysisPlatform: 'Data Analysis Platform',
    totalOperateState: 'Operating status',
    middle: 'well',
    score: '87marks',
    toolbar: {
      home: 'Home',
      statistic: 'Data Statistics',
      area: 'Area Management',
      equipment: 'Equipment Management',
      account: 'My Account',
      exit: 'Sign Out',
      fullScreen: 'Full Screen',
      exitFullScreen: 'Exit Full Screen',
    },
  },

  //Equipment.js
  deviceError: {
    number: 'No.',
    haveResolved: 'Resolved',
    haveNotResolved: 'Unsolved',
    reason: {
      contactFailure: 'Unresponsive device',
      communicateError: 'Response difficulty',
      measureDifficulty: 'Ranging difficulty',
      measureIncorrect: 'Measure inaccurate',
      restart: 'Device restart',
      deviceMiss: 'Missed device',
      other: 'Other',
    },
    noErrorDevice: 'None',
    tip: 'Warning',
    sure: 'Yes',
    cancel: 'Cancel',
    deleteAllRecord:
      'Confirm to delete all error records of this faulty device',
    confirmDelete: 'Confirm this action？',
    deviceProblem: {
      deviceFaulty: 'Faulty',
      totalDeviceFaulty: 'Total faulty devices',
      cannotCommunicate: 'Unresponsivable',
      hardToCommunicate: 'Poor-communication',
      hardToMeasure: 'Poor-ranging',
      incorrectMeasure: 'Poor-precision rate',
      otherErrorDevice: 'Other faulty',
      haveResolvedDevice: 'Resolved',
      deviceUnit: ' devices',
      name: 'name',
      number: 'number',
      type: 'type',
      status: 'status',
      total: 'total ',
      records: ' records',
    },
    page: {
      prevPage: 'previous',
      nextPage: 'next',
      total: 'total ',
      pages: ' pages',
      number: 'NO.',
    },
    records: {
      deleteAll: 'Delete all records',
      total: 'total ',
      recording: ' records',
      prev: 'previous',
      next: 'next',
    },
    allPlace: 'Total ',
    beilin: '碑林',
    expireDate: 'Expire date',
    allChecked: 'Check all',
    detail: {
      name: 'name',
      number: 'number',
      area: 'district',
      time: 'Expire date',
      status: 'status',
    },
    item: {
      area:
        '长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园长春腾花园',
      deviceNumber: 'NO.324434344444',
      region: '陕西省西安市',
      date: '2019/06/01',
      expired: '已到期',
      totalDevice: '共 9 个设备',
      prevPage: '上一页',
      pageNumber: '1',
      nextPage: '下一页',
      charge: '去续费',
    },
  },

  //account.js
  myAccount: {
    account: 'My Account',
    accountPartOne: {
      detail: 'Group Info',
      superAdmin: 'Super Administrator',
      commonAdmin: 'Administrator',
      accNumber: 'Account',
      tel: 'Phone',
      email: 'Email',
      address: 'Address',
      unset: 'None',
      detailInfo: {
        cleanUnit: '189',
        cleanerNumber: ' cleaners',
        carUnit: '189',
        carNumber: ' trucks',
      },
      edit: 'Edit',
      view: 'View',
    },
    accountPartTwo: {
      myDevice: 'My Device',
      deviceNumber: '<span>-</span>devices',
      // deviceInfo: '-- running,-- to renew,-- to assign',
      deviceInfo: '-- running,-- to assign',
      aboutDevice:
        '<1036 devices is running,3 devices need to renew,5 devices need to assign>',
      orderNewDevice: 'Order new equipment',
      rechargeNewDevice: 'Recharge',
      orderHistory: 'Historical orders',
      renewal: 'Renew',
    },
    accountPartThree: {
      myBalance: 'My Balance',
      balanceDetail: '$',
      charge: 'Recharge',
      chargeHistory: 'Charge history',
      todo: 'Prepare For',
      develop: 'developing...',
      you: 'You have',
      renew: 'device in urgent need of renewal.',
      toRenew: 'To renew >>',
      Allocate: 'device that is not assigned. Go assign it.',
      toAllocate: 'To manage personnel distribution. >>',
      improved: 'Your account information needs to be complete~',
      toImproved: 'To edit >>',
      know: 'I got it',
      empty: 'No to-do items~',
    },
    accountPartFour: {
      securitySet: 'Security Settings',
      login: 'Password',
      passwordSuggest: 'You can change your password here.',
      haveSet: 'Binded',
      modify: 'Modify',
      bindPhone: 'Bind',
      unset: 'Not binded',
      unsetDetail: 'You have not bind your phone',
      haveBind: 'You have bind your phone',
      useYourPhone:
        ' (Your phone can be used directly for login, retrieve password, etc.)',
      unbind: 'Unbind success',
      bind: 'Bind',
      toUnbind: 'Unbind',
      logout: 'Sign out',
      // logoutInfo:
      //   'If need to switch accounts or other logout requirements, you can log them out. Exit does not affect re-entry.'
    },
    bookNewDevice: {
      orderNewDevice: 'Order new one',
      commonSensor: 'Universal HIOS sensor',
      newGeneration: 'New generation',
      model: 'Type',
      storage: 'Storage',
      scene: 'Scenes',
      installationType: 'Installation type',
      format: 'Specification',
      quantity: 'devices',
      power: 'Power supply',
      transform: 'Communication mode',
      distance: 'Ranging distance',
      integrated: 'Integrated',
      help: 'Help',
      helpText:
        'The multi-probe integration model contains multiple probes, which can be used to integrate into a collection container containing multiple contents',
      position: 'Position',
      duration: 'Duration',
      order: 'Order',
      cancel: 'Cancel',
      free: 'Free ',
      yuan: ' CNY',
      multiple: ' sensors device',
      month: 'Months',
    },
    aboutBind: {
      successBind: 'Binding',
      wrongPhoneNumberFormat: 'Wrong format phone number',
      fillNumber: 'Please fill in the complete mobile number',
      wrongFormatNumber: 'Incorrect format of mobile number',
      numberHaveBound: 'Phone number is already bound',
      wrongVerifiedCode: 'Verification code error',
      sendCode: 'Get verified',
      modifyPhone: 'Modify phone',
      rebind: 'Bind phone',
      verifiedCode: 'Verify code',
      inputPhoneNumber: 'Input phone number need to bind',
      inputCode: 'Input verified code with 6-digit',
      sure: 'Yes',
      cancel: 'Cancel',
      inputRightPassword: 'Input right password',
      passRules:
        '6 to 18 digits (include letters, numbers, common characters, case sensitive)',
      inconsistentPasswords: 'Password dismatch ',
      originalFalse: 'Wrong original password',
      tryTwice: 'Login again',
      demands: 'Input the password (6-20 digits)',
      modify: 'Modify password',
      currPassword: 'Current password',
      inputCurr: 'Input current password',
      newPassword: 'New password',
      inputNewSet: 'Input new password',
      confirm: 'Confirm password',
      inputAgain: 'Input password again',
      edit: 'Edit',
      identify: 'Account identify',
      superAdmin: 'Super Administrator',
      admin: 'Administrator',
      completeness: 'Completeness 60%',
      companyName: 'Name of company',
      operator: 'Operator',
      inputOperatorName: 'Input name of operator',
      tel: 'Telephone',
      inputTel: 'Input telephone number',
      email: 'Email',
      inputEmail: 'Input email',
      address: 'Address',
      inputWorkspace: 'Input address',
      cleanerNumber: 'Cleaners number',
      carsNumber: 'Trucks number',
      finishedEdit: 'Finished edit',
    },
    show: {
      tab: 'Display',
    },
    editUser: {
      title: 'Edit',
      userGroup: 'User Group',
      integrity: 'Integrity',
      errorCompany:
        'Please enter the correct company name (not less than 6 digits)',
      errorEmail: 'please enter vaild email',
      errorNumber: 'Please enter correct number',
      errorPhone: 'Please enter correct phone number',
      staff: 'cleaners',
      car: 'trucks',
    },
    orderNew: {
      title: 'Order new equipment',
    },
  },
  //服务账户国际化
  serviceAccount: {
    serviceAccount: 'Service Account',
    accountManagement: 'Account Management',
    add: 'Add',
    export: 'Export',
    regionManagement: 'Region Management',
    superior: 'Superior',
    confirm: 'Confirm',
    cancel: 'Cancel',
    regionalLevel: 'Regional Level:',
    areaName: 'Region:',
    editAccount: 'Edit Account',
    automaticGeneration: 'Generate',
    userName: 'UserName',
    accountPassword: 'Password',
    regionName: 'Region',
    permissionSetting: 'Permission',
    initialPassword:'Initial Password',
    permission:'Permission',
    edit:'Edit',
    total:'Total ',
    users:' Users',
    all:'All',
    readOnly:'Read Only',
    confirmExportAll:'Confirm to export all accounts in current list',
    exportAccount:'Export Account',
    sureToDelete:'Are you sure you want to delete',
    NoteForDelete:' Note: delete region and account',
    EmptyNameWarning:'Region name cannot be empty',
    province:'Province',
    city:'City',
    region:'Region',
    street:'Street',
    community:'Community',
    enterTheInformation:'Please enter the information that meets the rule',
    addAccount:'Add Account',
    tips:'Tips',
    deleteSuccess:'Successfully deleted',
    deleteFailByReason:'There are subordinate administrative regions or equipment, which cannot be deleted',
    CompanyUnnamed:'Company Unnamed',
    pleaseSelect:'Please Select',


  },

  //TestTop.js
  mapDetail: {
    inputID: 'Input id',
    search: 'Search',
    refresh: 'Refresh',
  },

  //createArea.js
  areaPageDetail: {
    //创建大区表单
    districtCreate: {
      account: {
        duplicateAcc: 'Duplicate account',
        differentTwice: 'Retype your password!',
        districtAcc: 'District Account',
        accRules:
          'Starts with letters, 6 to 18 digits (include letters, numbers, underline)',
        inputAcc: 'Input your account!',
        placeholder: 'Input your account',
      },
      password: {
        pass: 'Password',
        passRules: '6 to 18 digits (include letters, numbers, underline)',
        inputPass: 'Input password',
        confirm: 'Confirm Password',
        inputPass2: 'Input password!',
        inputTwice: 'Input password again',
      },
      districtName: {
        name: 'District Name',
        inputName: 'Input district name',
        inputName2: 'Input district name!',
        rules: '(Support Chinese, English, numbers, underline)',
      },
      admin: {
        name: 'Administrator Name',
        inputName: 'Input administrator name',
        inputName2: 'Input administrator name!',
        rules: '(Support Chinese, English, numbers, underline)',
      },
      staff: {
        number: 'Staff Number(unit:cleaners)',
        wrongFormat: 'Wrong format!',
        unit: '(cleaners)',
        inputNumber: 'Input staff number',
      },
      vehicle: {
        number: 'Vehicle Number(unit:trucks)',
        wrongFormat: 'Wrong format!',
        unit: '(trucks)',
        inputNumber: 'Input vehicle number',
      },
      isCreate: 'Create',
      isCancel: 'Cancel',
      establish: 'Create',
      establishDistrict: 'Create District',
      completeness: 'Completeness',
    },
    //创建下属工作区表单
    subWorkAreaCreate: {
      duplicate: 'Duplicate account',
      Inconsistent: 'Retype your password!',
      workplace: {
        account: 'Workspace Account',
        rules:
          'Starts with letters, 6 to 18 digits (include letters, numbers, underline)',
        inputAccount: 'Input your account',
        inputAccount2: 'Input your account!',
      },
      password: {
        pass: 'Password',
        rules:
          '6 to 18 digits (include letters, numbers, common characters, case sensitive)',
        inputPass: 'Input password',
        confirmPass: 'Confirm Password',
        inputAgain: 'Input password again',
      },
      workspace: {
        name: 'Workspace Name',
        inputName: 'Input workspace name',
        inputName2: 'Input workspace name!',
        rules: '(Support Chinese, English, numbers, underline)',
      },
      cleanerName: {
        name: 'Cleaner Name',
        inputName: 'Input cleaner name',
        inputName2: 'Input cleaner name!',
        rules: '(Support Chinese, English, numbers, underline)',
      },
      filledWeight: {
        vehicleWeight: 'Full Vehicle Load(unit:kg)',
        wrongFormat: 'Wrong format!',
        inputWeight: 'Input full vehicle load',
      },
      isCreate: 'Create',
      isCancel: 'Cancel',
      establish: 'Create',
      establishSub: 'Create Subordinate Workspace Account',
      completeness: 'Completeness',
    },

    //编辑大区表单
    editDistrict: {
      districtInfo: {
        name: 'District Name',
        rule1: 'District name cannot be empty!',
        rule2: '(Support Chinese, English, numbers, underline)',
        inputName: 'Input district name',
      },
      admin: {
        manager: 'Administrator',
        rule1: 'Administrator name cannot be empty!',
        rule2: '(Support Chinese, English, numbers, underline)',
        inputName: 'Input administrator name',
      },
      contact: {
        contactInfo: 'Telephone',
        rule: 'Input correct phone number!',
        inputTel: 'Input phone number',
      },
      staff: {
        number: 'Staff Number(Unit:cleaners)',
        error: 'Wrong format!',
        inputNumber: 'Input staff number',
        unit: '(cleaners)',
      },
      vehicle: {
        number: 'Vehicle Number(Unit:trucks)',
        error: 'Wrong format!',
        unit: '(trucks)',
        inputNumber: 'Input vehicle number',
      },
      finished: 'Finish',
      cancel: 'Cancel',
      edit: 'Edit',
      districtName: 'District Account',
      completeness: 'Completeness',
    },

    //编辑工作区表单
    editWorkspace: {
      districtInfo: {
        name: 'Workspace Name',
        error: 'Workspace Name cannot be empty!',
        rule: '(Support Chinese, English, numbers, underline)',
        inputWorkspace: 'Input workspace name',
      },
      cleanerInfo: {
        cleaner: 'Cleaner',
        error: 'Cleaner name cannot be empty!',
        rule: '(Support Chinese, English, numbers, underline)',
        inputName: 'Input cleaner name',
      },
      contactInfo: {
        contactMethods: 'Telephone',
        error: 'Input correct phone number!',
        inputTel: 'Input phone number',
      },
      vehicle: {
        fullWeight: 'Full Vehicle Load(unit:kg)',
        error: 'Wrong format!',
        inputFullWeight: 'Input full vehicle load',
      },
      finished: 'Finish',
      cancel: 'Cancel',
      modify: 'Edit',
      workAreaAccount: 'Workspace Account',
      belong: 'District',
      completeness: 'Completeness',
    },
  },

  //MyAMap.js
  map: {
    refresh: 'Refresh',
  },

  //thermodynamic.js
  timeLine: {
    hour: 'h',
  },

  //help.jsx
  //帮助模块
  helpCenter: {
    title: 'Common Problem',
    category: 'Content',
    favor: 'What kind of help do you need？',
    search: 'Search areas',
    helpDetail: {
      area: 'Area Management',
      getAreaHelp: 'Get help about division and personnel management.',
      equipment: 'Equipment Management',
      getEquipment: 'Help about faulty equipment and recharge.',
      data: 'Statistics',
      getData: 'Get help about cleaner data, labor maps, and reduction data.',
      account: 'Account Management',
      getAccount:
        'Get help about my account, historical orders, message center.',
      noKey: 'No keywords found for you！',
    },
    suggest: {
      relative: 'Related questions you may find useful',
      difference: 'What\'s "District" and "Subordinate Workspace"?',
      workArea:
        'Workspace is an area for which a cleaner (driver) is responsible and the area is equipped with a cleaner (driver) account for work. Besides, a district is an integration of several Workspaces and is equipped with an admin account for management.',
      distribute: 'How to assign bins to places where you want?',
      install:
        "When installing devices, if you use a cleaner account named cleaner A, the devices will be assigned to cleaner A automatically. If you need to adjust later, please enter the Staff Management interface by using administrator's account and then assign the devices to other cleaners on PC.",
    },
    support: {
      download: 'Download MeetHive product introduction manual here: ',
      manual: {
        compose: 'Product introduction manual consists of seven parts: ',
        problem: 'Section Ⅰ  Industry Problem',
        introduce: 'Section Ⅱ  Meet Hive Introduction',
        product: 'Section Ⅲ  Product Introduction',
        case: 'Section Ⅳ  Product Case',
        install: 'Section Ⅴ  Install and Train',
        guarantee: 'Section Ⅶ  Qualification and Guarantee',
        about: 'Section Ⅷ  About MeetHive',
      },
    },
    contact: {
      humanService:
        "If you need artificial service, please send a phone call or email to our official mailbox and remember to note your company's name.",
      tele: 'Phone: +86-15399420457/029-87977358',
      email: 'Email: hive@hive-intel.com',
      address:
        'Address: Room 304, floor 3, international robot industrial base, Dongguan Songshan Lake high tech Industrial Development Zone',
      add2:
        "Room 907, Yamei Weibo Plaza, No.395, West Section of Second Ring South Road, Lianhu District, Xi'an City, Shaanxi Province",
    },
    official: {
      officialPc: 'HI-Sanitation web url',
      pcwebsite: 'http://pc.hive-intel.com',
      applet: 'HI-Sanitation WeChat applet',
      des: 'HI-Sanitation',
      titleDes: 'HI-Sanitation',
      appletDes: 'APP',
      installApplet: 'Device installation APP',
      position: 'HI-Sanitation bins positioning tool',
      positionTool: 'HI-Sanitation bins positioning tool',
      serviceAccount: 'WeChat service account',
      hiClear: 'HI-Sanitation clearance',
      serviceAcc: 'Service account',
      officialAcc: 'WeChat subscribe account',
      brand: 'Meet Hive蜂巢智慧',
      brand2: 'Meet Hive蜂巢智慧',
      subscribe: 'Subscriptions',
      officialWebsite: 'MeetHive official website',
      webAddress: 'http://hive-intel.com',
    },
    countenance: 'Supports',
    content: 'Contents',
    whatYouNeed: 'What kind of help do you need？',
    inputToSearch: 'Search you want ...',
    about: {
      downloadDocs: 'Download files',
      getFile: 'Get and browse documents about installation and trial guides.',
      contact: 'HI-Sanitation related contact',
      getTouch: 'Get help about HI Sanitation hotline and Email service.',
      official: 'HI-Sanitation official platform',
      getOfficial:
        'Get help about HI-Sanitation bins positioning tool, service account information.',
      contactUs: 'Contact Us',
      phone: '029-87977358',
      noKey: 'No keywords found for you！',
    },
  },
  //区域动态
  sanitation: {
    title: 'Regional dynamics',
    des1: 'There are currently ',
    des2: ' workspaces',
    cleanerBtn: 'Path',
    cleanerDetail: 'Details',
  },
  //路径规划
  pathPlanning: {
    map: {
      start: 'Starting point',
      end: 'End',
      setGarage: 'Selected as garage',
      setWarehouse: 'Selected as warehouse',
      expectedRecyclable: 'Will recycle',
      haveReceived: 'Have recycled',
      actually: 'Used',
      history: 'History',
      Intelligence: 'Original',
    },
    sure: 'Yes',
    cancel: 'Cancel',
    dialogTitle: 'Set intelligent planning parameters',
    noPoint:
      'The garage or warehouse location is not set, after setting the detailed path can be seen.',
    pointBtn: 'Apply',
    createNewPath: 'Create a new path',
    addressCanNotEmpty:
      'The garage warehouse needs to be set up together, please complete it!',
    garageTips: 'Please select a specific address！',
    startPoint: 'Start point',
    endPoint: 'End point',
    garageLabel: 'Garage',
    carSpace: 'Recycle vehicle space',
    carSpaceTips:
      'The recycle vehicle may not be in no-load state during planning, so this parameters need to be set',
    minVolume: 'Minimum quantity of recycle bin',
    minVolumeTips:
      'Recycle bins below this volume are not included in the intelligent planning',
    garagePlaceholder: 'Please input garage name',
    warehouseTips: 'Please select a specific address!',
    warehouseLabel: 'Warehouse',
    warehousePlaceholder: 'Please input warehouse name',
    setPointSuccess: 'Set up successfully!',
    setPointFail: 'Setting failed, please try again later!',
    clearRoute: 'Actual clearance route',
    clearDesKg: 'kg',
    clearDesKil: 'km',
    clearDesHour: 'hour',
    clearDesOne: 'Cleaned ',
    clearDesTwo: 'Drove',
    clearThree: 'Time consumed ',
    clearDesFour: 'Route efficiency ',
    historyRouteShow: 'Draw',
    historyRouteUnShow: 'Hide',
    historyRouteTitle: 'Historical intelligent planning route',
    historyDesOne: 'Will remove',
    historyDesTwo: 'Will drive',
    historyDesThree: 'Paras',
    historyFour: ' are not recycled',
    historyBuild: 'Created at ',
    historyCarSpace: 'Car space ',
    historyMinVolume: 'recycle bin ',
    planningTitle: 'Current intelligent planning route',
    noPlanningTips: 'No intelligent planning route',
    noPlanningTipsDes:
      'You can set up the intelligent planning route you want for cleaners here.',
    noPlanningBtn: 'Create',
    pageTipsTitle: 'Tips',
    pageTipsContent:
      'Please check whether the full vehicle weight is set. If the correct setting still fails to plan, please contact customer service.',
  },
  //规格管理页面
  specification: {
    unassigned: 'Unassigned',
    pageTitle: 'Specification management',
    searchContent: 'Enter what you are looking for here ...',
    selectAll: 'Select all',
    equipmentName: 'Devices name',
    equipmentId: 'Devices ID',
    areaChoseAll: 'Select all',
    specChoseAll: 'Select all',
    operating: 'Operating',
    modifySpec: 'Update',
    replace: 'Replace',
    specPackage: 'Specification package',
    sonCanName: 'Bins number',
    labelSpec: 'Label/Specification',
    addPackage: 'Spec package',
    packageName: 'Specification package name',
    household: 'Household',
    hazardous: 'Hazardous',
    residual: 'Residual',
    recyclable: 'Recyclable',
    customize: 'Customize',
    total: 'Total ',
    records: ' records',
    previous: 'Previous',
    next: 'Next',
    pages: ' pages',
    batchEdit: 'Batch edit',
    modifySpecInBatch: 'Modify specifications in batches',
    selected: 'Selected',
    devices: 'Devices',
    finishEdit: 'Finish',
    specificationList: 'Specification list',
    installHeight: 'Installation height',
    fullDevicesHeight: 'Full device height',
    fullDevicesWeight: 'Full device weight',
    meter: 'm',
    kilogram: 'kg',
    edit: 'Edit',
    delete: 'Delete',
    add: 'Spec',
    addNewSpecification: 'Add new specification',
    addTipsOne: 'The value should not be greater than 450 cm',
    addTipsTwo:
      'Full box height should not be greater than the installation height',
    addTipsThree:
      'The cabinet specification name is duplicated, please fill in and submit again.',
    addTipsFour:
      'The specifications of the cabinet are duplicated, please fill in and submit again.',
    completion: 'Completion',
    specificationName: 'Specification name',
    inputTips: 'Click on settings',
    inputErrTips: 'Please complete',
    inputErrTipsTwo: 'Please fill in the numbers',
    devicesType: 'Cabinet type',
    selectType: 'Please select the type!',
    clothingBox: 'Clothing device',
    trashBox: 'Trash device',
    transferBox: 'Transfer device',
    finish: 'Finish',
    cancel: 'Cancel',
    selectSpec: 'Select Specification',
    selectTips:
      'The selected specifications are selected at this moment. If there are other specifications, you can create new specifications on this page according to the requirements.',
    selectDes:
      'You are free to choose the specifications from the existing list.',
    installTips:
      '"Installation height" refers to the distance from the installation position of the device to the bottom of the box, and the measurement accuracy of the device can only be guaranteed if it is filled in correctly.',
    fullHeightTips:
      '"Full device height" refers to the position of the box full of alarm lines that your company believes. The correct measurement accuracy of the equipment can only be guaranteed if you fill it in correctly.',
    fullWeightTips:
      "'Full device weight' refers to the weight of the goods that can be collected when your company's box is full. Correct filling in can ensure the accuracy of the data on the year, month, and day statements.",
    tips: 'Tips',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    deleteContent: 'Please determine if you want to "Delete"',
    deleteErrTips: 'The current specifications cannot be deleted.',
    editTips:
      'There are devices that are using this specification and whether to apply changes to these cabinets. Click No to add new specifications.',
    error: {
      authority: 'You are not authorized to perform this operation.',
      nameRepeat:
        'The device specification name is duplicated, please fill in and submit again.',
      parameterRepeat:
        'The specifications of the device are duplicated, please fill in and submit again.',
      dragNum:
        'Please select the specification package that matches the equipment.',
      isUsing:
        'This specification package has a cabinet in use, it is forbidden to modify it, please create a new one',
    },
    replaceSpecPackage: 'Replace spec package',
    selectSpecPackage: 'Select specification package',
    confirmToReplace: 'Confirm',
    spePackageSameName: 'Duplicate specification package name',
    specPackSameParams:
      'There is a specification package with the same parameters',
  },
  power: {
    pageTitle: 'Power management',
    searchContent: 'Please enter the name or number to find',
    tableTitle: {
      selectAll: 'Select all',
      deviceName: 'Device name',
      deviceID: 'Device ID',
      areaAll: 'All',
      power: 'Remaining power',
      life: 'Expect life',
      month: 'month',
      sensitive: 'Report threshold',
      action: 'Action',
      button: 'modify',
      total: 'Total',
      device: 'items devices',
      multiChange: 'Multiple change',
      powerError: 'Power error',
      unassigned: 'Unassigned',
      unnamed: 'Unnamed',
    },
    tips: {
      title: 'tips',
      lineOne:
        'The modified threshold is used to dynamically balance the power consumption and real-time performance of the device.',
      lineTwo:
        'Lowering the threshold will improve the real-time performance of device data reporting, but it will also increase the power consumption of the device.',
      lineThree:
        'Increasing the threshold will reduce the power consumption of the device while reducing the real-time performance of device data reporting.',
      lineFour: 'Recommended threshold value range：5%~25%。',
    },
    change: {
      title: 'Modify threshold',
      original: 'Original threshold',
      new: 'New threshold',
      cancel: 'Cancel',
      confirm: 'Confirm',
      select: 'Selected',
      device: 'items devices',
    },
  },
  recharge: {
    pageTitle: 'Device Recharge',
    searchContent: 'Enter the object you want to find here',
    automaticRenewal: 'Automatic renewal',
    turnOn: 'Turn on',
    shutDown: 'shut Down',
    atWork: 'At work',
    expired: 'Expired',
    dueSoon: 'Due soon',
    toSettle: 'To renew',
    noPermission:
      'Insufficient authority, please contact the super administrator for operation',
  },
  orderHistory: {
    confirm: 'ok',
    reset: 'Reset',
    emptyText: 'No data',
    title: 'Historical orders',
    event: 'Event',
    number: 'Number',
    transactionHour: 'Time',
    amount: 'Amount',
    orderNum: 'Order number',
    equipmentOrder: 'Equipment order',
    equipmentRenewal: 'Equipment renewal',
    accountRecharge: 'Account recharge',
    other: 'other',
    orderState: {
      done: 'completed',
      close: 'closed',
      toBePaid: 'To be paid',
    },
    alipay: 'Alipay',
    weChatPay: 'WeChat pay',
    accountBalance: 'Account balance',
    toPay: 'Pay',
  },
  orderDetail: {
    year: 'years',
    month: 'months',
    title: 'Historical orders',
    orderDetail: 'Order detail',
    detail: 'Detail',
    orderNum: 'Order number',
    expirationTime: 'Payment expiration time',
    operating: 'Operating',
    pay: 'Pay',
    cancel: 'Cancel',
    state: 'Status',
    unpaid: 'Unpaid',
    orderTime: 'Order time',
    originalPrice: 'Original price',
    yuan: ' CNY',
    amountToPaid: 'Amount to be paid',
    orderPrice: 'Order price',
    payPrice: 'Payment amount',
    rechargeToAccount: 'The recharge has arrived, go to the',
    account: 'account',
    order: 'Order details',
    product: 'Product/Instance id',
    paymentMethod: 'Method',
    duration: 'Duration',
    expireDate: 'Expiry time after purchase',
    price: 'Price',
    model: 'Model',
    scenes: 'Scenes',
    poweredBy: 'Powered',
    communicationMode: 'Communication',
    rangingDistance: 'Ranging',
    integrationType: 'Integrated',
    none: 'none',
    integrationTxt: 'Integrated probe',
    typeOfInstallation: 'Install',
    position: 'Position',
    discount: 'Discount ',
    saving: 'Free ',
    view: 'View',
  },
  payProcess: {
    pay: 'Pay',
    minute: 'minute',
    second: 'second',
    payOrder: 'Order payment',
    accountNumber: 'Account number',
    transactionNumber: 'Transaction number',
    commodityOrder: 'Commodity order',
    originalOrder: 'Original order',
    paymentAmount: 'Payment amount',
    orderDetails: 'Order details',
    orderTime: 'Order time',
    payTheRemainingTime: 'Pay the remaining time',
    payResult: 'Payment result',
    paymentSuccessful: 'Payment successful',
    paymentFailed: 'Payment failed',
    close: 'close',
    weChatPay: 'Open the mobile phone WeChat, scan to complete the payment',
    alipay: 'Open mobile Alipay, scan to complete the payment',
  },
  payment: {
    confirm: {
      detail: 'Product Details',
      count: 'Total amount',
      duration: 'Duration',
      durationHelp:
        'After the device is activated, duration will start to be calculated',
      price: 'Price',
      autoCharge: 'Auto charge',
      info: 'Basic info',
      agree: 'I have read and agreed',
      licese:
        '《Meet Live Intelligence clothing recycling product service agreement》',
      totalFee: 'Total cost',
      confirm: 'Confirm',
      confirmPay: 'Confirm',
      year: 'Year',
      errorTips: 'Please check the product service agreement to purchase!',
      name: 'Name',
      partition: 'Partition',
      principal: 'Principal',
    },
    balance: {
      chargeAccount: 'Recharge Account',
      remain: 'Account Balance',
      charge: 'Recharge',
      chargePrice: 'Price',
      chargeTips: 'Recharge tips',
      chargeTipsFir: 'Recharge is non-refundable, please proceed with caution',
      chargeTipsSec:
        'The invoice can be issued after the recharged amount has been consumed',
    },
    charge: {
      availTime: 'Expire Time',
      chargeTime: 'Renewal Time',
      newAvailTime: 'After renewal',
      discountTip:
        'Purchase for half a year, based on a monthly prepaid preferential price, and then enjoy a 30% discount',
      action: 'Detail',
      viewDevice: 'View Device',
    },
    begin: {
      target: 'Trading target',
      company: 'Meet hive Intelligence Corporation Ltd.',
      order: 'order number',
      withBalance: 'Balance',
      availbleBalance: 'Availible balance',
      yuan: 'CNY',
      thirdPay: 'Pay with other',
      thirdPayHelp:
        'Online payment only supports the following three payment channels. After clicking "Pay Now", you can choose any one of them to pay on the newly opened page',
      thirdLimit: 'Transaction limit description',
      thirdLimitHelpFir:
        '1. The transaction limit of the Hive Smart Platform: 0.01-9999999 CNY;',
      thirdLimitHelpSec:
        '2. WeChat Pay/Alipay Pay/Online Banking will limit the transaction amount according to bank requirements to ensure the safety of your funds. Different payment platforms, different banks, and different card types correspond to different limits. For specific limits, please refer to your actual payment prompts;',
      thirdLimitHelpThi:
        '3. For large transactions, it is recommended that you use offline remittance to recharge.',
      totalFee: 'Order Fee',
      confirm: 'Confirm Pay',
      orderTips:
        'Reminder: Please complete the order payment within 15 minutes, the order will be automatically closed after 15 minutes',
      okText: 'Success Pay',
      cancelText: 'Pay fail',
      wait: 'Wait for pay...',
      autoCancel: 'second order will be closed.',
      newPage: 'Please complete the payment in the new page',
      reopen: ' Reopen',
      loading: 'Updating order status',
    },
    result: {
      success: 'Pay Success',
      fail: 'Pay Fail',
      successTo: 'seconds later entering the order details page',
      failTo: 'View order',
    },
    step: {
      confirm: 'Confirm Order',
      begin: 'Pay',
      result: 'Pay Result',
      info: 'Basic info',
    },
  },
}



// WEBPACK FOOTER //
// ./src/i18n/en-us.js